import type { AemData } from '@/lib/types/aem';

import type { PiSpaHighlightsResponse, PiSpaHighlight } from './SpaHighlight';

export const buildUrl = (
  { language, country, modelSeries }: Pick<AemData, 'language' | 'country' | 'modelSeries'>,
  brandId: string,
) =>
  `/graphql/execute.json/daimler/piSpaHighlightsByModelAndLocale;locale=${`${language}_${country}`};modelSeries=${modelSeries};subBrand=${brandId};`;

export const fetchHighlights = (url: string): Promise<PiSpaHighlight[]> =>
  fetch(url)
    .then((response) => response.json() as Promise<PiSpaHighlightsResponse>)
    .then(mapAndFilterResponse);

// filter data by the id of the fragment to avoid duplicates that can happen when HQ and market publish the same fragments
const mapAndFilterResponse = (d: PiSpaHighlightsResponse): PiSpaHighlight[] =>
  d.data.piSpaHighlightsList.items
    .map((it) => ({ ...it, slug: it._path.split('/').pop() }))
    .filter((item, i, self) => self.findIndex((t) => item.slug === t.slug) === i);
